/*
  CFG - Father's Day Sale countdown
  Drives any .fd-countdown[data-fd-deadline] element. Deadline is an absolute
  UTC instant (e.g. 2026-06-22T03:59:00Z = 6/21 11:59pm EDT), so the offset is
  handled correctly regardless of the visitor's timezone.
  When the deadline passes, the sale UI ([data-fd-sale]) is hidden as a
  client-side backstop to the Liquid scheduling in cfg-fathers-day-active.
*/
(function () {
  'use strict';

  var nodes = document.querySelectorAll('.fd-countdown[data-fd-deadline]');
  if (!nodes.length) return;

  function hideSaleUI() {
    document.querySelectorAll('[data-fd-sale]').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function format(deadline, node) {
    var diff = deadline - Date.now();

    if (diff <= 0) {
      hideSaleUI();
      return false;
    }

    var totalSeconds = Math.floor(diff / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    function unit(value, label) {
      return '<span class="fd-countdown__unit"><span class="fd-countdown__num">' +
        (value < 10 ? '0' + value : value) +
        '</span><span class="fd-countdown__label">' + label + '</span></span>';
    }

    node.innerHTML =
      '<span class="fd-countdown__lead">Sale ends in</span>' +
      unit(days, 'd') + unit(hours, 'h') + unit(minutes, 'm') + unit(seconds, 's');

    return true;
  }

  nodes.forEach(function (node) {
    var deadline = Date.parse(node.getAttribute('data-fd-deadline'));
    if (isNaN(deadline)) return;

    if (!format(deadline, node)) return;

    var timer = setInterval(function () {
      if (!format(deadline, node)) {
        clearInterval(timer);
      }
    }, 1000);
  });
})();
